<template>
	<div class="intellectual-btn +mask-one">
		<span class="intellectual-btn.mas">{{btnText.subText=="面议"?btnText.subText:('￥'+btnText.subText)}}</span>
		<!-- <button type="button" name="Hover" v-show="btnText.subText!='面议'">{{btnText.text}}</button> -->
	</div>
</template>

<script>
	export default{
		props:['btnText']
	}
</script>

<style lang="scss">
	@keyframes ani2 {
		from {
			-webkit-mask-position: 100% 0;
			mask-position: 100% 0;
		}

		to {
			-webkit-mask-position: 0 0;
			mask-position: 0 0;
		}
	}

	@keyframes ani {
		from {
			-webkit-mask-position: 0 0;
			mask-position: 0 0;
		}

		to {
			-webkit-mask-position: 100% 0;
			mask-position: 100% 0;
		}
	}

	@include component(intellectual-btn) {
		position: relative;
		width: 240px;
		height: 60px;
		overflow: hidden;
		border: 1px solid #F47227;
		transition: 0.5s;
		letter-spacing: 1px;
		
		border-radius: 5px;

		button {
			width: 101%;
			height: 100%;
			font-size: 20px;
			letter-spacing: 1px;
			background: #F47227;
			mask: url(https://raw.githubusercontent.com/robin-dela/css-mask-animation/master/img/urban-sprite.png);
			mask-size: 3000% 100%;
			border: none;
			outline: none;
			color: #fff;
			cursor: pointer;
			animation: ani2 0.7s steps(29) forwards;

			&:hover {
				animation: ani 0.7s steps(29) forwards;
			}
		}

		@include part(mas) {
			display: flex;
			align-items: center;
			justify-content: center;
			color: #fff;
			font-weight: bold;
			text-align: center;
			width: 100%;
			height: 100%;
			position: absolute;
			// margin-top: 10px;
			overflow: hidden;
			font-size: 30px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			background: #F47227;

		}


	}

	@include tweak(mask-one) {
		button {
			background: #F47227;
			mask: url(https://raw.githubusercontent.com/robin-dela/css-mask-animation/master/img/nature-sprite.png);
			mask-size: 2300% 100%;
			border: none;
			cursor: pointer;
			animation: ani2 0.7s steps(22) forwards;

			&:hover {

				animation: ani 0.7s steps(22) forwards;
			}
		}
	}

	@include tweak(mask-two) {
		button {
			background: #F47227;
			mask: url(https://github.com/robin-dela/css-mask-animation/blob/master/img/nature-sprite-2.png?raw=true);
			mask-size: 7100% 100%;
			border: none;
			color: #fff;
			cursor: pointer;
			animation: ani2 0.7s steps(70) forwards;

			&:hover {
				animation: ani 0.7s steps(70) forwards;
			}
		}
	}
</style>
